import { Reveal, Eyebrow } from "@/components/Reveal";
import { ABOUT_IMAGE, ABOUT_IMAGE_2 } from "@/data/clinic";

const CHAPTERS = [
  {
    num: "01",
    title: "Comfortable, unhurried visits",
    desc: "We take time to listen, explain and treat gently, so a dental visit never feels rushed or stressful.",
  },
  {
    num: "02",
    title: "Clear, honest guidance",
    desc: "Every treatment option is explained in simple language, so you always know what your teeth need and why.",
  },
  {
    num: "03",
    title: "Care for the whole family",
    desc: "From a child's first check-up to complete dentures for grandparents, every smile is welcome here.",
  },
];

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-[#FDFCF8] py-24 lg:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 lg:grid-cols-2 lg:px-10">
      <Reveal>
        <div className="relative">
          <div className="overflow-hidden rounded-3xl border border-[#D4AF37]/30 shadow-[0_20px_50px_rgba(6,58,47,0.12)]">
            <img
              src={ABOUT_IMAGE}
              alt="Dentist consulting a smiling patient in a modern clinic (illustrative photo)"
              loading="lazy"
              decoding="async"
              className="aspect-[4/3] w-full object-cover"
              data-testid="about-image"
            />
          </div>
          <div className="absolute -bottom-8 -right-4 hidden w-44 overflow-hidden rounded-2xl border-4 border-[#FDFCF8] shadow-xl sm:block lg:-right-8 lg:w-56">
            <img
              src={ABOUT_IMAGE_2}
              alt="Modern dental operatory with clean equipment (illustrative photo)"
              loading="lazy"
              decoding="async"
              className="aspect-square w-full object-cover"
            />
          </div>
        </div>
      </Reveal>

      <div>
        <Reveal>
          <Eyebrow>About Us</Eyebrow>
          <h2 className="font-display mt-5 text-4xl tracking-tight text-[#063A2F] sm:text-5xl">
            Dentistry that puts <span className="italic text-[#0D9488]">people</span> first
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-[#475569]">
            Smart Dental Clinic is a family dental practice in Bahadurpura, Hyderabad,
            led by Dr. Shaik Nayeem Ahmed. We bring a full range of dental treatments
            under one roof, with a simple promise — professional, comfortable and
            patient-friendly care for every person who walks through our door.
          </p>
        </Reveal>

        <div className="mt-8">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.12}>
              <div className="flex items-start gap-6 border-t border-[#063A2F]/10 py-6">
                <span className="font-display text-4xl leading-none text-[#D4AF37]/50">
                  {c.num}
                </span>
                <div>
                  <h3 className="text-base font-bold text-[#063A2F]">{c.title}</h3>
                  <p className="mt-1.5 max-w-lg text-sm leading-relaxed text-[#475569]">{c.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
